import { Anchor, Flex, Text } from '@mantine/core';
import { NavLink } from 'react-router';

type UserBreadcrumbsProps = {
  subPage: string;
};

export const UserBreadcrumbs = ({ subPage }: UserBreadcrumbsProps) => (
  <Flex gap={4} wrap='nowrap'>
    <Anchor to='/' component={NavLink} variant='gray'>
      Пользователи
    </Anchor>
    <Text>/</Text>
    <Text c='tertiary.4' truncate='end' maw='50dvw'>
      {subPage}
    </Text>
  </Flex>
);
